<template>
  <VpLoaderContainer class="vp-py-12" loading v-if="loading" />
  <NotAllowed v-else-if="!isWhatsAppCloudEnabled" />

  <VpListLayout
    v-else
    :add-route="{
      name: 'whatsapp-cloud-api-broadcast',
      params: { id: '+' },
    }"
    feature="WHATSAPP_BROADCAST"
    permission="upsert"
  >
    <VpList
      :per-page="25"
      :columns="columns"
      :endpoint="'whatsappCloudApiBroadcast'"
      class="vp-h-full"
      ref="list"
      :search="false"
      :request-payload="{
        query: $options.whatsappCloudApiBroadcast,
      }"
      :filters.sync="filters"
      :cache="'whatsappCloudApiBroadcasts'"
      :title="'Broadcast With Official API'"
      @rowClick="
        $router.push({
          name: 'whatsapp-cloud-api-broadcast-analytics',
          params: {
            id: $event.id,
          },
        })
      "
      feature="WHATSAPP_BROADCAST"
    >
      <template #filters>
        <VpField name="Template" label="Template">
          <VpInput>
            <VpSelect
              v-model="filters.templateId"
              :options="templates.map((t) => ({ label: t.name, value: t.id }))"
              placeholder="Select Template"
              clearable
              class="vp-w-64"
              @change="$refs.list.refresh()"
            />
          </VpInput>
        </VpField>
      </template>
      <template #empty>
        <VpListEmpty :feature="feature" route="whatsapp-cloud-api-broadcast" />
      </template>

      <template #template="{ item }">
        <div>{{ item.templateV2?.name }}</div>
      </template>

      <template #progress="{ item }">
        <ProgressBar class="vp-w-full" :progress="item.summary.progress" />
      </template>

      <template #status="{ item }">
        <Status :value="item.status" />
      </template>
    </VpList>
  </VpListLayout>
</template>

<script>
import ProgressBar from "@/components/progress-bar.vue";
import whatsappCloudApi from "./integration.gql";

import NotAllowed from "../_NotAllowed.vue";
import Status from "../_Status.vue";

//Marketing
import whatsappCloudApiBroadcast from "@/views/crm/marketing/whatsapp-broadcast/cloud-api/collection.gql";
import whatsappExtensionBroadcast from "@/views/crm/marketing/whatsapp-broadcast/extension/collection.gql";
import templates from "./templates.gql";

export default {
  whatsappCloudApiBroadcast,
  whatsappExtensionBroadcast,
  props: {
    feature: Object,
  },
  components: {
    ProgressBar,
    Status,
    NotAllowed,
  },
  data() {
    return {
      loading: false,
      isWhatsAppCloudEnabled: false,
      templates: [],
      filters: {
        templateId: "",
      },
    };
  },
  computed: {
    columns() {
      return [
        { name: "_index", label: "#", fix: true },
        { name: "name", type: "string" },
        { name: "template", type: "string" },
        { name: "progress", type: "string", width: "300px" },
        {
          name: "status",
          type: "string",
          fix: true,
        },
      ];
    },
  },
  created() {
    this.checkApi();
    this.getTemplates();
  },
  methods: {
    getTemplates() {
      return this.$query(templates, {
        page: 1,
        perPage: -1,
      }).then(({ data: { whatsappCloudApiBroadcastTemplates } }) => {
        this.templates = whatsappCloudApiBroadcastTemplates.data;
      });
    },
    checkApi() {
      this.loading = true;
      return this.$query(whatsappCloudApi)
        .then(({ data: { integrationWhatsappCloudApi } }) => {
          if (
            integrationWhatsappCloudApi &&
            integrationWhatsappCloudApi.isEnabled &&
            integrationWhatsappCloudApi.businessAccountId
          ) {
            this.isWhatsAppCloudEnabled = true;
          }
        })
        .finally(() => (this.loading = false));
    },
  },
};
</script>
